<i
    [class]="'icon-' + name"
    [class.small]="size === 'small'"
    [class.medium]="size === 'medium'"
    [class.large]="size === 'large'"
    [class.spin]="animation === 'spin'"
></i>
